
// Campust list
// ============
//
// Behaviour:
// ----------
// # Tablet
// Tapping / pressing a campus name will update the block to show the relevant 
// information for that campus, a details button will be shown for each campus 
// which will link to the campus specific page. Shares the same mobile
// 'View all on map' which opens a basic modal showing the map with all campuses
// marked and a link to google maps.
//
// # Desktop
// Hovering over campus title will updated the block to show the relevant campus
// information. Clicking the campus name will take the user to a page specific 
// to that campus.
//
// Notes:
// ------
// To determine the users screen width we measure the footer element as its 
// always full width and $(window).width is not consistent across different 
// browsers / devices.

$(document).ready(function() {

    $bodyElement       = $('body');
    $campusListElement = $('.campus-list');
    $footerElement     = $('.footer');

    // Set the active campus when click on a link (Tablet only)
    $('.campus-list__names-link').on('click', function(e) {
        if($footerElement.width() >= 768 && $footerElement.width() < 1200) {
            e.preventDefault(); // Stop the default click behaviour

            var campusId = $(this).attr('data-campus-id');

            updateActiveCampus(campusId);
        }       
    });

    // Set the active campus when hovering over a link (Desktop only)
    $('.campus-list__names-link').on('mouseenter', function(e) {
        if($footerElement.width() >= 1200) {
            var campusId = $(this).attr('data-campus-id');
            
            updateActiveCampus(campusId);
        }
    });

    function updateActiveCampus(campusId) {
        // Remove the active class from any currently active campus elements
        $('.active[data-campus-id!="' + campusId + '"]', $campusListElement).removeClass('active');
        
        // Add the active class to the required elements
        $('[data-campus-id="' + campusId + '"]', $campusListElement).addClass('active');
    }



    // Map popup open / close event listeners
    $('.campus-list__view-map').on('click', function(e) {
        e.preventDefault();

        $bodyElement.addClass('campus-map--open');
    });

    $('.campus-map__close, .campus-map-scrim').on('click', function(e) {
        e.preventDefault();

        $bodyElement.removeClass('campus-map--open');
    });
});